module.exports = __webpack_public_path__ + "img/ai.2ca83608.svg";